import { render } from "./CoverAlbumItem.vue?vue&type=template&id=08ff6aca"
import script from "./CoverAlbumItem.vue?vue&type=script&lang=js"
export * from "./CoverAlbumItem.vue?vue&type=script&lang=js"

import "./CoverAlbumItem.vue?vue&type=style&index=0&id=08ff6aca&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__